import React from "react";
import Accordion from "react-bootstrap/Accordion";
import "./HelpAccordion.scss";

interface Props {
  data?: any[];
}

function HelpAccordion({ data }: Props) {
  return (
    <Accordion>
      {data &&
        data?.length > 0 &&
        data?.map((val, index) => {
          if (!val) return null;
          return (
            <Accordion.Item eventKey={`${index}`} key={`${val?.Title}_${index}`}>
              <Accordion.Header>
                <div dangerouslySetInnerHTML={{ __html: val?.Title as string }} />
              </Accordion.Header>
              <Accordion.Body>
                <div dangerouslySetInnerHTML={{ __html: val?.Answer as string }} />
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
    </Accordion>
  );
}

export default HelpAccordion;
